var map = {
	"./history-of-tarot-cards.json": [
		690,
		690
	],
	"./how-to-ask-tarot-questions.json": [
		6130,
		6130
	],
	"./how-to-choose-a-tarot-spread.json": [
		3952,
		3952
	],
	"./how-to-interpret-tarot-card-combinations.json": [
		5222,
		5222
	],
	"./how-to-read-tarot-cards.json": [
		5777,
		5777
	],
	"./major-vs-minor-arcana.json": [
		1245,
		1245
	],
	"./tarot-for-self-reflection.json": [
		4330,
		4330
	],
	"./upright-vs-reversed-tarot-cards.json": [
		8522,
		8522
	],
	"./what-is-divination.json": [
		1734,
		1734
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5270;
module.exports = webpackAsyncContext;